<template>
  <span>
    You have exceeded the number of tries. Please wait 15 minutes before trying again or
    <h5
      id="resend"
    >reset your password</h5>
  </span>
</template>

<style lang="less" scoped>
#resend {
  cursor: pointer;
}
</style>
